exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio_row-item[data-v-6e403bd6]{margin-bottom:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.row-item[data-v-6e403bd6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.iconfont[data-v-6e403bd6]{font-size:24px}.color-box[data-v-6e403bd6]{position:relative;max-width:100%;min-height:1px}", ""]);

// exports
